export function RouterStatesAjs (
  $stateProvider     : ng.ui.IStateProvider,
  $urlRouterProvider : ng.ui.IUrlRouterProvider
) {
  $stateProvider
  .state('ajs', {
    abstract: true,
    template: '<ui-view></ui-view>',
    url     : '?disconnect'
  });

  $urlRouterProvider.otherwise('/login');
}
